module.exports = __webpack_public_path__ + "static/media/completed.6bebb44f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/roadmap/completed.png
// module id = 2187
// module chunks = 0